import React from "react"
import {PriceWrapperItem, StandardDeliveryContainer, StyledActionsContainer, TotalText} from "../../component"

export type StandardPriceAndDeliveryInfoProps = {
    isFirstSection: boolean
    totalText: string
    finalOrderValueFormatted: string
    description: string
}

export const StandardPriceAndDeliveryInfo = ({
    isFirstSection,
    totalText,
    finalOrderValueFormatted,
    description,
}: StandardPriceAndDeliveryInfoProps) => {
    return (
        <StyledActionsContainer isFirstSection={isFirstSection}>
            <PriceWrapperItem>
                <TotalText>{totalText}</TotalText>
                <span data-testid="header-mini-shopping-bag-total">{finalOrderValueFormatted}</span>
            </PriceWrapperItem>
            <StandardDeliveryContainer>
                <span>{description}</span>
            </StandardDeliveryContainer>
        </StyledActionsContainer>
    )
}

export default StandardPriceAndDeliveryInfo
